import { jsxs, jsx } from 'react/jsx-runtime';
import React__default, { useState, useRef, useEffect } from 'react';
import { parseUrlSafe } from '../../expandedResource.utils.js';
import { getCompatEnv } from '@fabric-app/compat/capabilities/environment';

const methodName = "createTweet";
const TwitterEmbed = ({ url, children }) => {
  const { TWITTER_EMBED_WIDGET_JS_URL } = getCompatEnv();
  const parsedUrl = parseUrlSafe(url);
  const tweetId = parsedUrl?.pathname.split("/")[3];
  const [loading, setLoading] = useState(true);
  const loadingRef = useRef(loading);
  loadingRef.current = loading;
  const [error, setError] = useState(null);
  const [tweetTarget, setTweetTarget] = useState(null);
  useEffect(() => {
    if (!tweetTarget || !loadingRef.current || !TWITTER_EMBED_WIDGET_JS_URL) return;
    tweetTarget.style.position = "absolute";
    setLoading(true);
    setError(null);
    const loadScript = async () => {
      try {
        const scriptjs = await import('scriptjs');
        scriptjs.default(TWITTER_EMBED_WIDGET_JS_URL, "twitter-embed", async () => {
          if (!window.twttr) {
            const error2 = new Error("Failure to load window.twttr, aborting load");
            console.error(error2.message);
            setLoading(false);
            setError(error2);
            return;
          }
          if (!window.twttr.widgets[methodName]) {
            const error2 = new Error(`Method ${methodName} is not present anymore in twttr.widget api`);
            console.error(error2.message);
            setLoading(false);
            setError(error2);
            return;
          }
          try {
            tweetTarget.innerHTML = "";
            await window.twttr.widgets[methodName](tweetId, tweetTarget);
          } catch (error2) {
            console.error(error2);
            if (error2 instanceof Error) setError(error2);
          } finally {
            setLoading(false);
            tweetTarget.style.position = "static";
          }
        });
      } catch (error2) {
        console.error("Failed to load scriptjs:", error2);
        setLoading(false);
        if (error2 instanceof Error) setError(error2);
      }
    };
    loadScript();
    return () => {
      tweetTarget.innerHTML = "";
    };
  }, [
    TWITTER_EMBED_WIDGET_JS_URL,
    tweetId,
    tweetTarget
  ]);
  if (!tweetId || !TWITTER_EMBED_WIDGET_JS_URL || error) {
    return children;
  }
  return /* @__PURE__ */ jsxs(React__default.Fragment, {
    children: [
      loading && children,
      /* @__PURE__ */ jsx("div", {
        ref: setTweetTarget
      })
    ]
  });
};

export { TwitterEmbed };
//# sourceMappingURL=TwitterEmbed.js.map
